<template>
    <div class="mt-2" v-if="account">
        <v-card class="pa-4 ma-3">
            <v-layout align-center justify-center>
                <v-card-title
                    class="text-xs-center headline px-0 mb-2 pt-0 mb-0 pb-0"
                >
                    <div
                        class="text-xs-center headline px-0 mb-2 pt-0 mb-0 pb-0"
                    >
                        וועד משמרת ד'סאטמאר
                    </div>
                    <div class="px-2">&#9679;</div>
                    <div
                        class="text-xs-center headline px-0 mb-2 pt-0 mb-0 pb-0"
                    >
                        וועד החינוך דסאטמאר
                    </div>
                </v-card-title>
            </v-layout>
            <v-form ref="form">
                <!-- <v-layout row>
                    <v-btn
                        small
                        class="mb-0 mt-0"
                        color="success"
                        :loading="uploading"
                        style="height: 35px;"
                        @click="pickFile()"
                        ><v-icon dark left>mdi-cloud-upload</v-icon
                        >Upload</v-btn
                    >
                    <input
                        type="file"
                        style="display: none"
                        ref="files"
                        accept="image/*,.pdf"
                        @change="onFilePicked($event)"
                    />
                    <v-btn
                        v-if="kollelApplication.documentURL"
                        small
                        class="mt-0 ml-3"
                        @click="openDocument()"
                        style="height: 35px;"
                    >
                        <v-icon color="red" left dark>mdi-file-pdf</v-icon>
                        <span class="mr-2">Kollel Application</span>
                        <v-icon right>mdi-download</v-icon>
                    </v-btn>
                    <v-btn
                        class="mt-0"
                        v-if="kollelApplication.documentURL"
                        small
                        icon
                        @click.stop="deleteDocument()"
                        ><v-icon color="red">mdi-delete-forever</v-icon></v-btn
                    >
                </v-layout> -->
                <div>
                    <v-layout row justify-end align-end class="mx-3">
                        <v-text-field
                            autocomplete="new-password"
                            label="היים טעלעפאן"
                            v-model="vmForm.homePhone"
                            ref="homePhone"
                            :rules="required"
                            v-bind:class="{
                                'vm-form-error': invalid('homePhone'),
                            }"
                            class="ml-3"
                            reverse
                        ></v-text-field>
                        <v-text-field
                            autocomplete="new-password"
                            label="אדרעס"
                            v-model="vmForm.address"
                            ref="address"
                            :rules="required"
                            class="ml-3"
                            v-bind:class="{
                                'vm-form-error': invalid('address'),
                            }"
                            reverse
                        ></v-text-field>
                        <v-text-field
                            autocomplete="new-password"
                            label="נאמען"
                            v-model="vmForm.name"
                            ref="name"
                            :rules="required"
                            v-bind:class="{ 'vm-form-error': invalid('name') }"
                            class="ml-3"
                            reverse
                        ></v-text-field>
                    </v-layout>
                    <v-layout row justify-end align-end class="mx-3">
                        <v-text-field
                            autocomplete="new-password"
                            label="אנדערע סעל"
                            v-model="vmForm.otherCell"
                            ref="otherCell"
                            class="ml-3"
                            reverse
                        ></v-text-field>
                        <v-text-field
                            autocomplete="new-password"
                            label="פרוי'ס סעל"
                            v-model="vmForm.wifeCell"
                            ref="wifeCell"
                            v-bind:class="{
                                'vm-form-error': invalid('wifeCell'),
                            }"
                            :rules="required"
                            class="ml-3"
                            reverse
                        ></v-text-field>
                        <v-text-field
                            autocomplete="new-password"
                            label="מאן'ס סעל 2"
                            v-model="vmForm.husbandCell2"
                            ref="husbandCell2"
                            class="ml-3"
                            reverse
                        ></v-text-field>
                        <v-text-field
                            autocomplete="new-password"
                            label="מאן'ס סעל 1"
                            v-model="vmForm.husbandCell1"
                            ref="husbandCell1"
                            v-bind:class="{
                                'vm-form-error': invalid('husbandCell1'),
                            }"
                            :rules="required"
                            class="ml-3"
                            reverse
                        ></v-text-field>
                    </v-layout>
                    <v-layout row justify-end align-end class="mx-3">
                        <v-text-field
                            autocomplete="new-password"
                            label="טעל"
                            v-model="vmForm.workPhone"
                            v-bind:class="{
                                'vm-form-error': invalid('workPhone'),
                            }"
                            ref="workPhone"
                            :rules="required"
                            class="ml-3"
                            reverse
                        ></v-text-field>
                        <v-text-field
                            autocomplete="new-password"
                            label="אדרעס פון ארבעט"
                            v-model="vmForm.workAddress"
                            v-bind:class="{
                                'vm-form-error': invalid('workAddress'),
                            }"
                            ref="workAddress"
                            :rules="required"
                            class="ml-3"
                            reverse
                        ></v-text-field>
                        <v-text-field
                            autocomplete="new-password"
                            label="נאמען פון ארבעט'ס פלאץ"
                            v-model="vmForm.nameOfWorkplace"
                            v-bind:class="{
                                'vm-form-error': invalid('nameOfWorkplace'),
                            }"
                            ref="nameOfWorkplace"
                            :rules="required"
                            class="ml-3"
                            reverse
                        ></v-text-field>
                    </v-layout>
                    <v-layout row justify-end align-end class="mx-3">
                        <v-text-field
                            autocomplete="new-password"
                            label="פילטער"
                            v-model="vmForm.workFilter"
                            v-bind:class="{
                                'vm-form-error': invalid('workFilter'),
                            }"
                            ref="workFilter"
                            :rules="required"
                            class="ml-3"
                            reverse
                        ></v-text-field>
                        <v-text-field
                            autocomplete="new-password"
                            label="אימעיל אדרעס"
                            v-model="vmForm.email"
                            ref="email"
                            class="ml-3"
                            reverse
                        ></v-text-field>
                    </v-layout>

                    <v-layout row justify-end align-end>
                        <v-spacer></v-spacer>
                        <v-text-field
                            v-if="vmForm.businessType == 'employed'"
                            autocomplete="new-password"
                            label="בעה''ב"
                            v-model="vmForm.boss"
                            v-bind:class="{
                                'vm-form-error': invalid('boss'),
                            }"
                            ref="boss"
                            :rules="required"
                            class="mx-3"
                            reverse
                        ></v-text-field>
                        <v-radio-group
                            v-model="vmForm.businessType"
                            row
                            style="max-width: 250px;"
                        >
                            <v-radio
                                label="ארבעטער"
                                value="employed"
                                color="success"
                            ></v-radio>
                            <v-radio
                                label="אייגענע ביזנעס"
                                value="own"
                                color="success"
                            ></v-radio>
                        </v-radio-group>
                    </v-layout>

                    <div class="pb-2 mx-3 mt-0 text-xs-right">
                        אויב זענט איר א: מלמד/מגי"ש/כולל, שרייבט עס אריין ביים
                        נאמען פון ארבעט'ס פלאץ *
                    </div>

                    <div
                        style="background-color: #4caf50; color: #fff"
                        class="py-2 mx-3 body-2 text-xs-center"
                    >
                        <div class="mb-0">
                            {{ getMessage("INSTRCTION1") }}
                        </div>
                        <div class="mb-0">
                            {{ getMessage("INSTRCTION2") }}
                        </div>
                    </div>

                    <div class="mx-3">
                        <v-layout row class="pa-0 mx-0 mt-3">
                            <v-divider
                                style="border-color: #4caf50; margin-top: 14px !important;"
                                class="pt-2"
                            ></v-divider>
                            <div class="font-weight-medium ml-2 title">
                                בעסיק טעלעפאנען
                            </div>
                        </v-layout>
                        <v-layout row justify-end align-end>
                            <v-spacer></v-spacer>
                            <div>{{ getMessage("CELLPHONE_DONT_HAVE") }}</div>
                            <v-checkbox
                                class="mt-1 ml-2"
                                style="max-width: 20px;"
                                v-model="vmForm.dontHaveBasicPhone"
                                color="success"
                                hide-details
                                reverse
                            ></v-checkbox>
                        </v-layout>

                        <v-layout row justify-end align-end>
                            <v-spacer></v-spacer>
                            <v-select
                                color="success"
                                :items="['ניין', 'יא']"
                                v-model="vmForm.hasBasicPhoneMeshimer"
                                class="mt-3"
                                reverse
                                style="max-width: 300px"
                                :label="getMessage('BLOCKED_BY_MESHIMER')"
                            ></v-select
                        ></v-layout>

                        <v-layout
                            row
                            justify-end
                            align-end
                            v-if="vmForm.hasBasicPhoneMeshimer == 'יא'"
                        >
                            <v-spacer></v-spacer>
                            <v-text-field
                                autocomplete="new-password"
                                label=""
                                v-model="vmForm.basicPhoneMeshimer"
                                ref="basicPhoneMeshimer"
                                class="mr-3 pt-0 mt-0"
                                :rules="required"
                                reverse
                                v-bind:class="{
                                    'vm-form-error': invalid(
                                        'basicPhoneMeshimer',
                                    ),
                                }"
                            ></v-text-field>
                            <div class="pb-3">
                                {{ getMessage("ENTER_MESHIMER") }}
                            </div>
                            <!-- <div class="width-100"></div>
                            <div>{{ getMessage("BLOCKED_BY_MESHIMER") }}</div>
                            <v-checkbox
                                class="mt-1 ml-2"
                                style="max-width: 20px;"
                                v-model="vmForm.hasBasicPhoneMeshimer"
                                color="success"
                                hide-details
                                reverse
                            ></v-checkbox> -->
                        </v-layout>

                        <v-layout
                            row
                            justify-end
                            align-end
                            v-if="showBasicPhoneErrorMessage"
                        >
                            <v-spacer></v-spacer>
                            <div class="text-danger mt-1 font-weight-bold">
                                קלויבט אויס איינע פון די אפציעס
                            </div></v-layout
                        >

                        <v-layout row justify-end align-end>
                            <v-spacer></v-spacer>
                            <div class="font-weight-bold">
                                {{ getMessage("WIFE_NO_SMARTPHONE") }}
                            </div>
                            <v-checkbox
                                class="mt-2 ml-2"
                                style="max-width: 20px;"
                                v-model="vmForm.wifeNoSmartphone"
                                color="success"
                                hide-details
                                reverse
                            ></v-checkbox>
                        </v-layout>
                        <v-layout
                            row
                            justify-end
                            align-end
                            v-if="showWifeNoSmartphoneMessage"
                        >
                            <v-spacer></v-spacer>
                            <div class="text-danger mt-1 font-weight-bold">
                                Required
                            </div></v-layout
                        >
                        <v-layout row justify-end align-end>
                            <v-spacer></v-spacer>
                            <div class="font-weight-bold">
                                {{ getMessage("WIFE_NO_QINPHONE") }}
                            </div>
                            <v-checkbox
                                class="mt-2 ml-2"
                                style="max-width: 20px;"
                                v-model="vmForm.wifeNoQinPhone"
                                color="success"
                                hide-details
                                reverse
                            ></v-checkbox>
                        </v-layout>
                        <v-layout
                            row
                            justify-end
                            align-end
                            v-if="showWifeNoQinphoneMessage"
                        >
                            <v-spacer></v-spacer>
                            <div class="text-danger mt-1 font-weight-bold">
                                Required
                            </div></v-layout
                        >

                        <v-layout row class="pa-0 mx-0 mt-3">
                            <v-divider
                                style="border-color: #4caf50; margin-top: 14px !important;"
                                class="pt-2"
                            ></v-divider>
                            <div class="font-weight-medium ml-2 title">
                                סמארט פאונ'ס/טעבלעט'ס
                            </div>
                        </v-layout>

                        <v-layout row justify-end align-end>
                            <div class="mr-2">
                                {{ getMessage("SMARTPHONE_QUESTION2") }}
                            </div>
                            <div class="font-weight-bold">
                                {{ getMessage("SMARTPHONE_QUESTION1") }}
                            </div>
                        </v-layout>
                        <v-layout row justify-end align-end>
                            <v-spacer></v-spacer>
                            <div>{{ getMessage("SMARTPHONE_DONT_HAVE") }}</div>
                            <v-checkbox
                                class="mt-1 ml-2"
                                style="max-width: 20px;"
                                v-model="vmForm.dontHaveSmartphone"
                                color="success"
                                hide-details
                                reverse
                            ></v-checkbox>
                        </v-layout>
                        <v-layout row justify-end align-end>
                            <v-spacer></v-spacer>
                            <v-text-field
                                autocomplete="new-password"
                                label="אייפעד"
                                v-model="vmForm.iPadCount"
                                ref="iPadCount"
                                style="max-width: 100px;"
                                class="ml-3"
                                reverse
                                hide-details
                            ></v-text-field>
                            <v-text-field
                                autocomplete="new-password"
                                label="טעבלעט"
                                v-model="vmForm.tabletCount"
                                ref="tabletCount"
                                style="max-width: 100px;"
                                class="ml-3"
                                reverse
                                hide-details
                            ></v-text-field>
                            <v-text-field
                                autocomplete="new-password"
                                label="בלעקבערי"
                                v-model="vmForm.blackberryCount"
                                ref="blackberryCount"
                                style="max-width: 100px;"
                                class="ml-3"
                                reverse
                                hide-details
                            ></v-text-field>
                            <v-text-field
                                autocomplete="new-password"
                                label="אייפאון"
                                v-model="vmForm.iPhoneCount"
                                ref="iPhoneCount"
                                style="max-width: 100px;"
                                class="ml-3"
                                reverse
                                hide-details
                            ></v-text-field>
                            <v-text-field
                                autocomplete="new-password"
                                label="ענדרויד"
                                v-model="vmForm.androidCount"
                                ref="androidCount"
                                style="max-width: 100px;"
                                class="ml-3"
                                reverse
                                hide-details
                            ></v-text-field>
                        </v-layout>
                        <v-layout
                            row
                            justify-end
                            align-end
                            v-if="showDeviceCountErrorMessage"
                        >
                            <v-spacer></v-spacer>
                            <div class="text-danger mt-1 font-weight-bold">
                                לייגט אריין א נומער
                            </div></v-layout
                        >
                        <v-layout row justify-end align-end>
                            <v-spacer></v-spacer>
                            <v-text-field
                                autocomplete="new-password"
                                label=""
                                v-model="vmForm.smartPhoneMeshimer"
                                ref="smartPhoneMeshimer"
                                class="ml-3"
                                hide-details
                                reverse
                            ></v-text-field>
                            <div class="ml-2">
                                {{ getMessage("SMARTPHONE_MESHIMER_ACCOUNT") }}
                            </div>
                        </v-layout>

                        <v-layout row class="pa-0 mx-0 mt-3">
                            <v-divider
                                style="border-color: #4caf50; margin-top: 14px !important;"
                                class="pt-2"
                            ></v-divider>
                            <div class="font-weight-medium ml-2 title">
                                קאמפיוטער/לעפטאפ - אין שטוב/בעיסמענט
                            </div>
                        </v-layout>
                        <v-layout row justify-end align-end>
                            <v-spacer></v-spacer>
                            <div>{{ getMessage("COMPUTER_DONT_HAVE") }}</div>
                            <v-checkbox
                                class="mt-1 ml-2"
                                style="max-width: 20px;"
                                v-model="vmForm.dontHaveHomeComputer"
                                color="success"
                                hide-details
                                reverse
                            ></v-checkbox>
                        </v-layout>
                        <v-layout row justify-end align-end>
                            <v-spacer></v-spacer>
                            <v-select
                                color="success"
                                :items="['ניין', 'יא']"
                                v-model="vmForm.isHomeComputerBlocked"
                                class="mt-3"
                                reverse
                                style="max-width: 300px"
                                :label="getMessage('BLOCKED_BY_MESHIMER')"
                            ></v-select
                        ></v-layout>

                        <v-layout
                            row
                            justify-end
                            align-end
                            v-if="vmForm.isHomeComputerBlocked == 'יא'"
                        >
                            <v-spacer></v-spacer>
                            <v-text-field
                                autocomplete="new-password"
                                label=""
                                v-model="vmForm.homeComputerMeshimer"
                                ref="homeComputerMeshimer"
                                class="mr-3 pt-0 mt-0"
                                hide-details
                                :rules="required"
                                reverse
                                v-bind:class="{
                                    'vm-form-error': invalid(
                                        'homeComputerMeshimer',
                                    ),
                                }"
                            ></v-text-field>
                            <div>{{ getMessage("ENTER_MESHIMER") }}</div>
                            <!-- <div class="width-100"></div>
                            <div>{{ getMessage("BLOCKED_BY_MESHIMER") }}</div>
                            <v-checkbox
                                class="mt-1 ml-2"
                                style="max-width: 20px;"
                                v-model="vmForm.isHomeComputerBlocked"
                                color="success"
                                hide-details
                                reverse
                            ></v-checkbox> -->
                        </v-layout>

                        <v-layout row justify-end align-end>
                            <v-spacer></v-spacer>
                            <v-select
                                color="success"
                                :items="['ניין', 'יא']"
                                v-model="vmForm.isHomeComputerFiltered"
                                class="mt-3"
                                reverse
                                style="max-width: 300px"
                                :label="getMessage('FILTERED_BY_MESHIMER')"
                            ></v-select
                        ></v-layout>

                        <v-layout
                            row
                            justify-end
                            align-end
                            v-if="vmForm.isHomeComputerFiltered == 'יא'"
                        >
                            <v-spacer></v-spacer>
                            <v-text-field
                                autocomplete="new-password"
                                label=""
                                v-model="vmForm.homeComputerMeshimerAccount"
                                ref="homeComputerMeshimerAccount"
                                class="mr-3 pt-0 mt-0"
                                hide-details
                                :rules="required"
                                reverse
                                v-bind:class="{
                                    'vm-form-error': invalid(
                                        'homeComputerMeshimerAccount',
                                    ),
                                }"
                            ></v-text-field>
                            <div>
                                {{ getMessage("ENTER_MESHIMER_ACCOUNT") }}
                            </div>
                            <!-- <div class="width-100"></div>
                            <div>{{ getMessage("FILTERED_BY_MESHIMER") }}</div>
                            <v-checkbox
                                class="mt-0 ml-2"
                                style="max-width: 20px;"
                                v-model="vmForm.isHomeComputerFiltered"
                                color="success"
                                hide-details
                                reverse
                            ></v-checkbox> -->
                        </v-layout>
                        <v-layout
                            row
                            justify-end
                            align-end
                            v-if="showHomeComputerErrorMessage"
                        >
                            <v-spacer></v-spacer>
                            <div class="text-danger mt-1 font-weight-bold">
                                קלויבט אויס איינע פון די אפציעס
                            </div></v-layout
                        >
                        <v-layout row class="pa-0 mx-0 mt-3">
                            <v-divider
                                style="border-color: #4caf50; margin-top: 14px !important;"
                                class="pt-2"
                            ></v-divider>
                            <div class="font-weight-medium ml-2 title">
                                ארבעט'ס פלאץ
                                <span class="body-2">פרוי/טאכטער</span>
                            </div>
                        </v-layout>
                        <v-layout row justify-end align-end>
                            <v-spacer></v-spacer>
                            <v-select
                                color="success"
                                :items="['ניין', 'יא']"
                                v-model="vmForm.wifeHasJob"
                                class="my-0"
                                :rules="required"
                                reverse
                                v-bind:class="{
                                    'vm-form-error': !vmForm.wifeHasJob,
                                }"
                                style="max-width: 300px"
                                label="האט די בעה''ב'סטע א דזשאב"
                            ></v-select
                        ></v-layout>

                        <v-layout
                            row
                            justify-end
                            align-end
                            v-if="vmForm.wifeHasJob == 'יא'"
                        >
                            <v-text-field
                                autocomplete="new-password"
                                label="פילטער"
                                v-model="vmForm.wifeWorkFilter"
                                ref="wifeWorkFilter"
                                :rules="required"
                                class="ml-3"
                                v-bind:class="{
                                    'vm-form-error': invalid('wifeWorkFilter'),
                                }"
                                reverse
                            ></v-text-field>
                            <v-text-field
                                autocomplete="new-password"
                                label="היים טעלעפאן"
                                v-model="vmForm.wifeWorkPhone"
                                ref="wifeWorkPhone"
                                class="ml-3"
                                reverse
                            ></v-text-field>
                            <v-text-field
                                autocomplete="new-password"
                                label="אדרעס"
                                v-model="vmForm.wifeWorkAddress"
                                ref="wifeWorkAddress"
                                class="ml-3"
                                reverse
                            ></v-text-field>
                            <v-text-field
                                autocomplete="new-password"
                                label="נאמען"
                                v-model="vmForm.wifeNameOfWorkplace"
                                ref="wifeNameOfWorkplace"
                                class="ml-3"
                                :rules="required"
                                v-bind:class="{
                                    'vm-form-error': invalid(
                                        'wifeNameOfWorkplace',
                                    ),
                                }"
                                reverse
                            ></v-text-field>
                            <div class="ml-2 pb-3 font-weight-bold title">
                                - פרוי
                            </div>
                        </v-layout>
                        <v-layout
                            row
                            justify-end
                            align-end
                            v-if="vmForm.wifeHasJob == 'יא'"
                        >
                            <v-spacer></v-spacer>
                            <v-text-field
                                autocomplete="new-password"
                                label="בעה''ב"
                                v-model="vmForm.wifeBoss"
                                ref="wifeBoss"
                                v-bind:class="{
                                    'vm-form-error': invalid('wifeBoss'),
                                }"
                                :rules="required"
                                class="mx-3"
                                reverse
                            ></v-text-field>
                            <v-radio-group
                                v-model="vmForm.wifeBusinessType"
                                row
                                style="max-width: 250px;"
                            >
                                <v-radio
                                    label="ארבעטער"
                                    value="employed"
                                    color="success"
                                ></v-radio>
                                <v-radio
                                    label="אייגענע ביזנעס"
                                    value="own"
                                    color="success"
                                ></v-radio>
                            </v-radio-group>
                        </v-layout>

                        <v-layout row justify-end align-end>
                            <v-spacer></v-spacer>
                            <v-select
                                color="success"
                                :items="['ניין', 'יא']"
                                v-model="vmForm.daughterHasJob"
                                class="my-0"
                                v-bind:class="{
                                    'vm-form-error': !vmForm.daughterHasJob,
                                }"
                                :rules="required"
                                reverse
                                style="max-width: 300px"
                                label="האט אייער טאכטער א דזשאב"
                            ></v-select
                        ></v-layout>
                        <v-layout
                            row
                            justify-end
                            align-end
                            v-if="vmForm.daughterHasJob == 'יא'"
                        >
                            <v-text-field
                                autocomplete="new-password"
                                label="פילטער"
                                v-model="vmForm.daughterWorkFilter"
                                ref="daughterWorkFilter"
                                v-bind:class="{
                                    'vm-form-error': invalid(
                                        'daughterWorkFilter',
                                    ),
                                }"
                                class="ml-3"
                                :rules="required"
                                reverse
                            ></v-text-field>
                            <v-text-field
                                autocomplete="new-password"
                                label="היים טעלעפאן"
                                v-model="vmForm.daughterWorkPhone"
                                ref="daughterWorkPhone"
                                class="ml-3"
                                reverse
                            ></v-text-field>
                            <v-text-field
                                autocomplete="new-password"
                                label="אדרעס"
                                v-model="vmForm.daughterWorkAddress"
                                ref="daughterWorkAddress"
                                class="ml-3"
                                reverse
                            ></v-text-field>
                            <v-text-field
                                autocomplete="new-password"
                                label="נאמען"
                                v-model="vmForm.daughterNameOfWorkplace"
                                v-bind:class="{
                                    'vm-form-error': invalid(
                                        'daughterNameOfWorkplace',
                                    ),
                                }"
                                ref="daughterNameOfWorkplace"
                                class="ml-3"
                                :rules="required"
                                reverse
                            ></v-text-field>
                            <div class="ml-2 pb-3 font-weight-bold title">
                                - טאכטער
                            </div>
                        </v-layout>
                        <v-layout
                            row
                            justify-end
                            align-end
                            v-if="vmForm.daughterHasJob == 'יא'"
                        >
                            <v-spacer></v-spacer>
                            <v-text-field
                                autocomplete="new-password"
                                label="בעה''ב"
                                v-model="vmForm.daughterBoss"
                                v-bind:class="{
                                    'vm-form-error': invalid('daughterBoss'),
                                }"
                                ref="daughterBoss"
                                :rules="required"
                                class=""
                                reverse
                            ></v-text-field>
                        </v-layout>
                    </div>

                    <v-text-field
                        class="mx-3"
                        autocomplete="new-password"
                        label="באמערקונגען"
                        v-model="vmForm.note"
                        ref="note"
                        reverse
                    ></v-text-field>
                </div>

                <div
                    class="text-xs-center mx-3"
                    v-html="getMessage('DECLERATION')"
                ></div>

                <v-layout row class="mt-2">
                    <v-spacer></v-spacer>
                    <div class="mb-0 headline">
                        מיר באשטעטיגן אז אלעס וואס איז געשריבן אויבן איז אמת
                    </div>
                    <v-checkbox
                        class="ml-2 mt-0 pb-3"
                        v-model="verifyForm"
                        color="success"
                        hide-details
                    ></v-checkbox>
                </v-layout>
                <div
                    class="text-danger text-xs-center font-weight-bold"
                    v-if="showMissingVerification"
                >
                    Please check the box above
                </div>
            </v-form>
            <v-card-actions class="mr-0 mt-0 pb-0">
                <v-btn
                    color="warning"
                    :loading="processing"
                    dark
                    @click="saveVmForm(true)"
                >
                    Approve Temporary
                </v-btn>
                <v-btn
                    color="success"
                    :loading="processing"
                    @click="saveVmForm"
                >
                    Save
                </v-btn>
                <v-btn dark color="default" @click="cancel">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>
<script>
import { formatPhoneNumber, except, toTitleCase } from "../../utils/helpers.js";
import moment from "moment";

export default {
    data() {
        return {
            account: "",
            vmFormDialog: false,
            vmFormDialogWidth: "800",
            processing: false,
            uploading: false,
            files: [],
            vmForms: [],
            vmFormsMessages: [],

            required: [(value) => !!value || "Required."],

            pdfDucmentNumberOfPages: "",

            pageCount: 0,
            currentPage: 0,

            verifyForm: false,
            showMissingVerification: false,
            showDeviceCountErrorMessage: false,
            showBasicPhoneErrorMessage: false,
            showHomeComputerErrorMessage: false,
            showWifeNoSmartphoneMessage: false,
            showWifeNoQinphoneMessage: false,

            vmForm: {
                name: "",
                address: "",
                homePhone: "",
                husbandCell1: "",
                husbandCell2: "",
                otherCell: "",
                wifeCell: "",
                nameOfWorkplace: "",
                workAddress: "",
                workPhone: "",
                email: "",
                workFilter: "",
                businessType: "",
                boss: "",
                androidCount: "",
                iPhoneCount: "",
                blackberryCount: "",
                tabletCount: "",
                iPadCount: "",
                smartPhoneMeshimer: "",
                dontHaveSmartphone: "",
                dontHaveBasicPhone: "",
                hasBasicPhoneMeshimer: "",
                wifeNoSmartphone: "",
                wifeNoQinPhone: "",
                isHomeComputerFiltered: "",
                isHomeComputerBlocked: "",
                basicPhoneMeshimer: "",
                dontHaveHomeComputer: "",
                homeComputerMeshimer: "",
                homeComputerMeshimerAccount: "",
                homeComputerFilterType: "",
                wifeNameOfWorkplace: "",
                wifeHasJob: "",
                wifeWorkAddress: "",
                wifeWorkPhone: "",
                wifeWorkFilter: "",
                wifeBusinessType: "",
                wifeBoss: "",
                daughterHasJob: "",
                daughterNameOfWorkplace: "",
                daughterWorkAddress: "",
                daughterWorkPhone: "",
                daughterWorkFilter: "",
                daughterBoss: "",
                note: "",
            },
        };
    },
    async created() {
        await this.loadAccount();

        const response = await this.$http.get(
            "api/vmForms/getApplication?accountID=" + this.account.accountID,
        );

        this.vmForms = response.vmForms;

        this.fillForm({ id: this.$route.params.id });

        this.loadStrings();
    },
    computed: {},
    methods: {
        async loadAccount() {
            this.account = await this.$http.get(
                "api/accounts/GetAccount?accountID=" +
                    this.$route.params.accountid,
            );
        },
        formatPhoneNumber(phone) {
            return formatPhoneNumber(phone);
        },
        getMessage(key) {
            if (!this.vmFormsMessages.length) return;

            return this.vmFormsMessages.find((m) => m.key == key).value;
        },
        pickFile() {
            this.$refs.files.click();
        },
        async onFilePicked(e) {
            // this.uploading = true;
            // const files = e.target.files;
            // if (!files) return;
            // try {
            //     var formData = new FormData();
            //     this.files = files;
            //     formData.append("upload_file", this.files[0]);
            //     const response = await this.$http.post(
            //         "api/kollelForms/uploadKollelApplication?accountID=" +
            //             this.account.accountID,
            //         formData,
            //         {
            //             headers: {
            //                 "Content-Type": "multipart/form-data",
            //             },
            //         }
            //     );
            //     this.kollelApplication.documentURL = response;
            //     this.uploading = false;
            // } catch (e) {
            //     this.uploading = false;
            // }
        },
        openDocument() {
            //window.open(this.kollelApplication.documentURL);
        },
        deleteDocument() {
            this.kollelApplication.documentURL = "";
        },
        async fillForm({ id = null }) {
            this.vmForm.name = this.account.hname;
            this.vmForm.homePhone = this.account.homePhone;
            this.vmForm.address = this.account.address1;

            const form = id
                ? this.vmForms.find((f) => f.id == id)
                : this.vmForms.length
                ? this.vmForms[0]
                : undefined;

            if (form) {
                this.vmForm.id = form.id;
                this.vmForm.name = form.name;
                this.vmForm.address = form.address
                    ? form.address
                    : this.account.address1;
                this.vmForm.homePhone = form.homePhone
                    ? form.homePhone
                    : this.account.homePhone;
                this.vmForm.husbandCell1 = form.husbandCell1;
                this.vmForm.husbandCell2 = form.husbandCell2;
                this.vmForm.otherCell = form.otherCell;
                this.vmForm.wifeCell = form.wifeCell;
                this.vmForm.nameOfWorkplace = form.nameOfWorkplace;
                this.vmForm.workAddress = form.workAddress;
                this.vmForm.workPhone = form.workPhone;
                this.vmForm.email = form.email;
                this.vmForm.workFilter = form.workFilter;
                this.vmForm.businessType = form.businessType;
                this.vmForm.boss = form.boss;
                this.vmForm.androidCount = form.androidCount;
                this.vmForm.iPhoneCount = form.iPhoneCount;
                this.vmForm.blackberryCount = form.blackberryCount;
                this.vmForm.tabletCount = form.tabletCount;
                this.vmForm.iPadCount = form.iPadCount;
                this.vmForm.smartPhoneMeshimer = form.smartPhoneMeshimer;
                this.vmForm.dontHaveSmartphone = form.dontHaveSmartphone;
                this.vmForm.dontHaveBasicPhone = form.dontHaveBasicPhone;
                this.vmForm.hasBasicPhoneMeshimer =
                    form.hasBasicPhoneMeshimer === null
                        ? ""
                        : form.hasBasicPhoneMeshimer
                        ? "יא"
                        : "ניין";
                this.vmForm.wifeNoSmartphone = form.wifeNoSmartphone;
                this.vmForm.wifeNoQinPhone = form.wifeNoQinPhone;
                this.vmForm.isHomeComputerFiltered =
                    form.isHomeComputerFiltered === null
                        ? ""
                        : form.isHomeComputerFiltered
                        ? "יא"
                        : "ניין";
                this.vmForm.isHomeComputerBlocked =
                    form.isHomeComputerBlocked === null
                        ? ""
                        : form.isHomeComputerBlocked
                        ? "יא"
                        : "ניין";
                this.vmForm.basicPhoneMeshimer = form.basicPhoneMeshimer;
                this.vmForm.dontHaveHomeComputer = form.dontHaveHomeComputer;
                this.vmForm.homeComputerMeshimer = form.homeComputerMeshimerStickerID
                    ? form.homeComputerMeshimerStickerID
                    : form.isHomeComputerBlocked
                    ? form.homeComputerMeshimer
                    : "";
                this.vmForm.homeComputerMeshimerAccount = form.isHomeComputerFiltered
                    ? form.homeComputerMeshimer
                    : "";
                this.vmForm.homeComputerFilterType =
                    form.homeComputerFilterType;
                this.vmForm.wifeNameOfWorkplace = form.wifeNameOfWorkplace;
                this.vmForm.wifeHasJob =
                    form.wifeNameOfWorkplace ||
                    form.wifeWorkAddress ||
                    form.wifeWorkPhone ||
                    form.wifeWorkFilter ||
                    form.wifeBusinessType ||
                    form.wifeBoss
                        ? "יא"
                        : "ניין";
                this.vmForm.daughterHasJob =
                    form.daughterNameOfWorkplace ||
                    form.daughterWorkAddress ||
                    form.daughterWorkPhone ||
                    form.daughterWorkFilter ||
                    form.daughterBoss
                        ? "יא"
                        : "ניין";
                this.vmForm.wifeWorkAddress = form.wifeWorkAddress;
                this.vmForm.wifeWorkPhone = form.wifeWorkPhone;
                this.vmForm.wifeWorkFilter = form.wifeWorkFilter;
                this.vmForm.wifeBusinessType = form.wifeBusinessType;
                this.vmForm.wifeBoss = form.wifeBoss;
                this.vmForm.daughterNameOfWorkplace =
                    form.daughterNameOfWorkplace;
                this.vmForm.daughterWorkAddress = form.daughterWorkAddress;
                this.vmForm.daughterWorkPhone = form.daughterWorkPhone;
                this.vmForm.daughterWorkFilter = form.daughterWorkFilter;
                this.vmForm.daughterBoss = form.daughterBoss;
                this.vmForm.note = form.note;
                this.verifyForm = form.signatureBase64String ? true : false;
            }

            this.$refs.form.resetValidation();

            this.vmFormDialog = true;
        },
        async loadStrings() {
            this.vmFormsMessages = await this.$http.get(
                "api/vmForms/getStrings",
            );
        },
        collectFormData() {
            return {
                id: this.vmForm.id,
                name: this.vmForm.name,
                address: this.vmForm.address,
                updatedBy: this.$store.state.authentication.user,
                homePhone: this.vmForm.homePhone
                    ? this.vmForm.homePhone.replace(/\D/g, "")
                    : "",
                husbandCell1: this.vmForm.husbandCell1
                    ? this.vmForm.husbandCell1.replace(/\D/g, "")
                    : "",
                husbandCell2: this.vmForm.husbandCell2
                    ? this.vmForm.husbandCell2.replace(/\D/g, "")
                    : "",
                otherCell: this.vmForm.otherCell
                    ? this.vmForm.otherCell.replace(/\D/g, "")
                    : "",
                wifeCell: this.vmForm.wifeCell
                    ? this.vmForm.wifeCell.replace(/\D/g, "")
                    : "",
                nameOfWorkplace: this.vmForm.nameOfWorkplace,
                workAddress: this.vmForm.workAddress,
                workPhone: this.vmForm.workPhone
                    ? this.vmForm.workPhone.replace(/\D/g, "")
                    : "",
                email: this.vmForm.email,
                workFilter: this.vmForm.workFilter,
                businessType: this.vmForm.businessType,
                boss: this.vmForm.boss,
                androidCount: this.vmForm.androidCount,
                iPhoneCount: this.vmForm.iPhoneCount,
                blackberryCount: this.vmForm.blackberryCount,
                tabletCount: this.vmForm.tabletCount,
                iPadCount: this.vmForm.iPadCount,
                smartPhoneMeshimer: this.vmForm.smartPhoneMeshimer,
                dontHaveBasicPhone: this.vmForm.dontHaveBasicPhone,
                basicPhoneMeshimer: this.vmForm.basicPhoneMeshimer,
                dontHaveSmartphone: this.vmForm.dontHaveSmartphone,
                hasBasicPhoneMeshimer:
                    this.vmForm.hasBasicPhoneMeshimer == "יא",
                wifeNoSmartphone: this.vmForm.wifeNoSmartphone,
                wifeNoQinPhone: this.vmForm.wifeNoQinPhone,
                isHomeComputerFiltered:
                    this.vmForm.isHomeComputerFiltered == "יא",
                isHomeComputerBlocked:
                    this.vmForm.isHomeComputerBlocked == "יא",
                dontHaveHomeComputer: this.vmForm.dontHaveHomeComputer,
                homeComputerMeshimerStickerID:
                    this.vmForm.isHomeComputerBlocked == "יא"
                        ? this.vmForm.homeComputerMeshimer
                        : null,
                homeComputerMeshimer: this.vmForm.homeComputerMeshimerAccount,
                homeComputerFilterType: this.vmForm.homeComputerFilterType,
                //wifeHasJob: this.vmForm.wifeHasJob,
                daughterHasJob: this.vmForm.daughterHasJob,
                wifeNameOfWorkplace: this.vmForm.wifeNameOfWorkplace,
                wifeWorkAddress: this.vmForm.wifeWorkAddress,
                wifeWorkPhone: this.vmForm.wifeWorkPhone
                    ? this.vmForm.wifeWorkPhone.replace(/\D/g, "")
                    : "",
                wifeWorkFilter: this.vmForm.wifeWorkFilter,
                wifeBusinessType: this.vmForm.wifeBusinessType,
                wifeBoss: this.vmForm.wifeBoss,
                daughterNameOfWorkplace: this.vmForm.daughterNameOfWorkplace,
                daughterWorkAddress: this.vmForm.daughterWorkAddress,
                daughterWorkPhone: this.vmForm.daughterWorkPhone
                    ? this.vmForm.daughterWorkPhone.replace(/\D/g, "")
                    : "",
                daughterWorkFilter: this.vmForm.daughterWorkFilter,
                daughterBoss: this.vmForm.daughterBoss,
                note: this.vmForm.note,
            };
        },

        isMissingDeviceCount() {
            const androidCount = this.vmForm.androidCount;
            const iPhoneCount = this.vmForm.iPhoneCount;
            const blackberryCount = this.vmForm.blackberryCount;
            const tabletCount = this.vmForm.tabletCount;
            const iPadCount = this.vmForm.iPadCount;
            const dontHaveSmartphone = this.vmForm.dontHaveSmartphone;

            if (dontHaveSmartphone) return false;

            return (
                !androidCount &&
                !iPhoneCount &&
                !blackberryCount &&
                !tabletCount &&
                !iPadCount
            );
        },
        isMissingBasicPhoneInfo() {
            const dontHaveBasicPhone = this.vmForm.dontHaveBasicPhone;
            const hasBasicPhoneMeshimer = this.vmForm.hasBasicPhoneMeshimer;

            return !dontHaveBasicPhone && !hasBasicPhoneMeshimer;
        },
        isMissingHomeComputerInfo() {
            const dontHaveHomeComputer = this.vmForm.dontHaveHomeComputer;
            const isHomeComputerBlocked = this.vmForm.isHomeComputerBlocked;
            const isHomeComputerFiltered = this.vmForm.isHomeComputerFiltered;

            return (
                !dontHaveHomeComputer &&
                !isHomeComputerBlocked &&
                !isHomeComputerFiltered
            );
        },
        invalid(field) {
            if (!this.$refs[field]) return;

            return !this.$refs[field].validate();
        },
        cancel() {
            this.$router.push({
                name: "VmForms",
            });
        },
        async saveVmForm(approveTemporary = false) {
            this.showMissingVerification = false;
            this.showDeviceCountErrorMessage = false;
            this.showBasicPhoneErrorMessage = false;
            this.showHomeComputerErrorMessage = false;
            this.showWifeNoSmartphoneMessage = false;
            this.showWifeNoQinphoneMessage = false;

            if (!approveTemporary) {
                const invalid =
                    !this.$refs.form.validate(true) ||
                    this.isMissingDeviceCount() ||
                    this.isMissingBasicPhoneInfo() ||
                    !this.vmForm.wifeNoSmartphone ||
                    !this.vmForm.wifeNoQinPhone ||
                    this.isMissingHomeComputerInfo();

                if (invalid) {
                    if (this.isMissingDeviceCount()) {
                        this.showDeviceCountErrorMessage = true;
                    }

                    if (this.isMissingBasicPhoneInfo()) {
                        this.showBasicPhoneErrorMessage = true;
                    }

                    if (!this.vmForm.wifeNoSmartphone) {
                        this.showWifeNoSmartphoneMessage = true;
                    }

                    if (!this.vmForm.wifeNoQinPhone) {
                        this.showWifeNoQinphoneMessage = true;
                    }

                    if (this.isMissingHomeComputerInfo()) {
                        this.showHomeComputerErrorMessage = true;
                    }

                    return;
                }

                if (!this.verifyForm) {
                    this.showMissingVerification = true;
                    return;
                }
            } else {
                if (!this.vmForm.wifeNoSmartphone) {
                    this.showWifeNoSmartphoneMessage = true;

                    return;
                }
            }

            try {
                this.processing = true;

                const response = await this.$http.post("api/vmForms/Save", {
                    form: this.collectFormData(),
                    approveTemporary: approveTemporary,
                });

                this.processing = false;

                if (approveTemporary) {
                    this.$notify({
                        text: "Account Has Been Temporary Approved",
                        group: "notification",
                        type: "success",
                    });
                }

                this.$router.push({
                    name: "VmForms",
                });
            } catch (e) {
                console.log(e);
                this.processing = false;
            }
        },
    },
};
</script>
<style>
.card-width {
    max-width: 65%;
}
.vm-form-error .error--text {
    color: #f55a4e !important;
    font-weight: 700 !important;
}
.vm-form-error .v-input__slot::after {
    border-color: #f55a4e !important;
    border-width: 3px !important;
}
</style>
